export default __webpack_public_path__ + "static/media/walk_sway.764f6de3.gif";